import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";

import { ENDPOINT, Routes } from "../../../constants";

import TextField from "../../../components/TextField";
import Button from "../../../components/Button";
import { FetchApi } from "../../../api/fetch";

const ChangePassword = React.memo(() => {
  const history = useHistory();

  const onFinish = useCallback(() => {
    toast.success('Password Reset Succesful');
    history.push(Routes.LOGIN);
  }, [history]);


   const onResetPassword = async (email: string, code: string, newPassword: string, actions: any) => {
      try {
         await FetchApi({
          endpoint:`${ENDPOINT.BASE_AUTH}/reset-password`, 
          method: "POST",
          body:  ({email,newPassword, code}),
        })
  
        onFinish()
      } catch (error: any) {
        actions.setSubmitting(false);
      }
  
    };

  return (
    <div className="flex-col max-w-4xl mx-auto px-2 mt-8 sm:px-6 lg:px-4  lg:mt-16">
      <div className="md:shadow-lg md:p-8 flex-col items-center">
        <h1 className="h1 mb-2">CHANGE PASSWORD</h1>
        <p className="text-md text-center mb-8">
          Enter your new password
        </p>
        <Formik
          validateOnBlur={false}
          initialValues={{
            email: "",
            code: "",
            newPassword: "",
            error: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .trim()
              .required("Please enter your email address.")
              .email("Must be a valid email."),
            code: Yup.string()
              .trim()
              .required("Please enter your verification code."),
          })}
          onSubmit={({ error, email, code, newPassword }, actions) => {
            onResetPassword(email, code, newPassword, actions)

          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form
              onSubmit={handleSubmit}
              noValidate
              className="max-w-lg mx-auto flex flex-col items-center"
            >
              <ErrorMessage name="error" />
              <TextField
                type="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                showError={touched.email && Boolean(errors.email)}
                required
                id="email"
                name="email"
                autoComplete="email"
                placeholder="Email"
                label="Email"
              />
              <TextField
                type="text"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.code}
                showError={touched.code && Boolean(errors.code)}
                required
                id="code"
                name="code"
                placeholder="Enter Verification Code"
                label="Verification Code"
              />
              <TextField
                type="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.newPassword}
                showError={touched.newPassword && Boolean(errors.newPassword)}
                required
                id="newPassword"
                name="newPassword"
                placeholder="Type your new password"
                label="New Password"
              />
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full btn bg-gradient text-kyzzen-primary font-medium"
              >
                SUBMIT
              </Button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
});

export default ChangePassword;
